import { useState, useEffect, useContext, useRef } from "react";
import GlobalContext from "../../providers/GlobalProvider";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import "./CostCenter.css";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/esm/Button";
import Select from "react-select";

const CostCenter = ({ kind }) => {
  const navigate = useNavigate();
  const [matchesList, setMatchesList] = useState([]);
  const [selectedOp, setSelectedOp] = useState();
  const [selectedAccounting, setSelectedAccounting] = useState();
  const [filteredOps, setFilteredOps] = useState([]);
  const [filteredAccounting, setFilteredAccounting] = useState([]);
  const [costCenterValue, setCostCenterValue] = useState(kind || "");
  const [loading, setLoading] = useState(true);
  const { defaultMapper } = useContext(GlobalContext);
  const costCenterOptions = { 1: "op1Id", 2: "op2Id", 3: "op3Id" };
  const costCenterOptions2 = { 1: "op1Ids", 2: "op2Ids", 3: "op3Ids" };
  const BASEURL = "/api/cost-centers";
  const IASLiveMapper = "IAS Libra Live";
  const otherSelectRef = useRef(null);
  const getOpData = async () => {
    setLoading(true);
    try {
      let response = await axios.get(`${BASEURL}/${kind}`);
      const { ops, accounting, matchingData1, matchingData2, matchingData3 } =
        response.data;
      // Create a mapping object for `kind` values
      const kindMapping = {
        1: matchingData1,
        2: matchingData2,
        3: matchingData3,
      };

      // Get the matching data based on `kind`
      setMatchesList(kindMapping[kind]);
      setFilteredOps(ops);
      setFilteredAccounting(accounting);

      const costCenterInt = parseInt(costCenterValue);
      const newMatches = kindMapping[kind].map((obj) => ({
        ops: {
          id: obj[costCenterOptions[costCenterInt]],
          display: `${findAndSpliceOps(
            ops,
            obj[costCenterOptions[costCenterInt]]
          )}`,
        },
        accounting: {
          id: obj[costCenterOptions2[costCenterInt]],
          description: `${findAccounting(
            accounting,
            obj[costCenterOptions2[costCenterInt]]
          )}`,
        },
      }));
      console.log(newMatches);
      setMatchesList([...newMatches]);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };
  const getId = (id) => {
    let splitId = id.split("-");
    if (splitId.length > 1) {
      return splitId[1].trim();
    }
    return id;
  };
  const findAndSpliceOps = (array, id) => {
    const selectedObj = array.find(
      (obj) => getId(obj.id).toLowerCase() === getId(id).toLowerCase()
    );
    if (selectedObj) {
      const invNum = selectedObj.display;
      const objIndex = array.findIndex((obj) => obj.id === id);
      // Remove the object from the array
      if (objIndex !== -1) {
        array.splice(objIndex, 1);
      }
      return invNum;
    }
  };

  const findAccounting = (array, id) => {
    const selectedObj = array.find(
      (obj) => obj.id.toString() === id.toString()
    );
    if (selectedObj) {
      const invNum = selectedObj.description;
      const objIndex = array.findIndex((obj) => obj.id == id);
      // if (objIndex !== -1) {
      //   array.splice(objIndex, 1);
      // }
      return invNum;
    }
  };

  useEffect(() => {
    setMatchesList([]);
    if (kind) {
      const fetchData = async () => {
        try {
          await getOpData();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    } else {
      setLoading(false);
    }
  }, [costCenterValue, defaultMapper]);

  // move to utils file
  // handles IAS Ids : "Invoice - <number>" or "Price - <number>"
  // and PRFD ids >> numbers
  const filterData = (array, selectedId) => {
    if (!selectedId) return array;
    let compositeId = selectedId.split("-");
    if (compositeId.length == 1) {
      return array.filter((obj) => obj.id != +selectedId);
    } else {
      return array.filter((obj) => obj.id != selectedId);
    }
  };

  const handleSaveClick = async (e) => {
    if (selectedAccounting && selectedOp) {
      try {
        // setFilteredOps(filterData(filteredOps, +selectedOp.id));
        setFilteredOps(filterData(filteredOps, selectedOp.id));

        const newMatch = {
          ops: {
            id: selectedOp.id,
            display: selectedOp.display,
          },
          accounting: {
            id: JSON.stringify(selectedAccounting.id),
            description: selectedAccounting.description,
            accNum: selectedAccounting.accNum,
          },
        };
        setMatchesList([...matchesList, newMatch]);

        const matchesData = {
          [`Op${costCenterValue}Id`]: newMatch.ops.id,
          [`Op${costCenterValue}Ids`]: newMatch.accounting.id,
          AccNum: newMatch.accounting.accNum,
        };
        await axios.post(`${BASEURL}/${kind}`, matchesData);
      } catch (e) {
        console.error("Error in HandleSaveClick", e);
      }
      setSelectedAccounting(null);
      setSelectedOp(null);
      populateOps();
    } else {
      return;
    }
  };
  const getOptionLabel = (option, displayProperty) => option[displayProperty];
  const getOptionValue = (option, idProperty) => option[idProperty];

  const getOpsOptionLabel = (option) => getOptionLabel(option, "display");
  const getOpsOptionValue = (option) => getOptionValue(option, "id");

  const getAccountingOptionLabel = (option) =>
    getOptionLabel(option, "description");
  const getAccountingOptionValue = (option) => getOptionValue(option, "id");

  const handleAccountingChange = (event) => {
    if (event) {
      const selectedId = event.id;
      const description = event.description;
      const acc = filteredAccounting.find((acc) => acc.id == selectedId);
      setSelectedAccounting({
        id: selectedId,
        description: description,
        accNum: acc.accNum,
      });
    }
  };

  const handleOpChange = (event) => {
    if (event) {
      const selectedId = event.id;
      const display = event.display;
      setSelectedOp({
        id: selectedId,
        display: display,
      });
    }
  };

  const populateOps = () => {
    if (filteredOps && filteredOps.length > 0) {
      let initialIndex = 0;
      let lastIndex = filteredOps.length;

      if (selectedOp && selectedOp.id) {
        initialIndex = filteredOps.findIndex(
          (obj) => obj.id.toString() == selectedOp.id.toString()
        );
      }
      // last object in the array
      if (initialIndex + 1 == lastIndex) {
        initialIndex = 0;
      } else {
        initialIndex++;
      }
      let firstOption = filteredOps[initialIndex];
      setSelectedOp({
        id: firstOption.id,
        display: firstOption.display,
      });
      // set focus on the accounting dropdown
      if (otherSelectRef.current) {
        otherSelectRef.current.focus();
      }
    } else {
      setSelectedOp(null);
    }
  };
  const handleDeleteClick = async (id) => {
    try {
      const updatedMatches = matchesList.filter((match) => match.ops.id !== id);
      setMatchesList(updatedMatches);
      await axios.delete(`${BASEURL}/${kind}/${id}`);
    } catch (e) {
      console.error("Error deleting this match", e);
    }
  };

  const handleSelectCostCenter = (event) => {
    setCostCenterValue(event.target.value);
    navigate(`/cost-center-${event.target.value}`);
  };

  if (loading) {
    return (
      <div>
        <ClipLoader
          loading={loading}
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }
  return (
    <div className="mapping-container">
      {defaultMapper != IASLiveMapper && (
        <div className="options-div selectors">
          <select onChange={handleSelectCostCenter} value={costCenterValue}>
            <option value="">Select a Cost Center</option>
            {Object.keys(costCenterOptions).map((cc) => (
              <option key={cc} value={cc}>
                {cc}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="col-2 mb-1 ms-4">
        <div className="d-grid gap-2">
          <button
            className="btn btn-outline-primary  w-70"
            onClick={() => populateOps()}
          >
            Populate Ops
          </button>
        </div>
      </div>
      {kind ? (
        <div className="mt-4 mb-4">
          <Table hover bordered="false" responsive order>
            <thead>
              <tr>
                <th>Ops</th>
                <th>Accounting</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {matchesList && matchesList.length > 0 ? (
                matchesList.map((match) => {
                  const opData = match.ops;
                  const accountingData = match.accounting;
                  return (
                    <tr key={match.ops.id}>
                      <td>{opData.display}</td>
                      <td>{accountingData.description}</td>
                      <td>
                        <Button
                          variant="outline-danger"
                          onClick={() => handleDeleteClick(match.ops.id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4">No matches found</td>
                </tr>
              )}
              <tr>
                <td>
                  <div>
                    {filteredOps && filteredOps.length > 0 ? (
                      <Select
                        menuPlacement="top"
                        options={filteredOps}
                        getOptionLabel={(option) => getOpsOptionLabel(option)}
                        getOptionValue={(option) => getOpsOptionValue(option)}
                        onChange={handleOpChange}
                        isClearable={true}
                        isSearchable={true}
                        placeholder="Select an option"
                        value={selectedOp}
                      />
                    ) : (
                      <p>No data</p>
                    )}
                  </div>
                </td>
                <td>
                  <div>
                    {filteredAccounting && filteredAccounting.length > 0 ? (
                      <Select
                        ref={otherSelectRef}
                        menuPlacement="top"
                        options={filteredAccounting}
                        getOptionLabel={(option) =>
                          getAccountingOptionLabel(option)
                        }
                        getOptionValue={(option) =>
                          getAccountingOptionValue(option)
                        }
                        onChange={handleAccountingChange}
                        isClearable={true}
                        isSearchable={true}
                        placeholder="Select an option"
                        value={selectedAccounting}
                      />
                    ) : (
                      <p>No Data</p>
                    )}
                  </div>
                </td>
                {selectedOp?.id && selectedAccounting?.id ? (
                  <td>
                    <Button
                      onClick={handleSaveClick}
                      // disabled={disabled}
                      variant="outline-success"
                      style={{ marginTop: "0px" }}
                    >
                      Save
                    </Button>
                  </td>
                ) : (
                  <td></td>
                )}
              </tr>
            </tbody>
          </Table>
          <Link to="/">
            <Button variant="outline-danger">Main Menu</Button>
          </Link>
        </div>
      ) : (
        <p>Choose a Cost Center to Proceed</p>
      )}
    </div>
  );
};

export default CostCenter;
